import { useCallback, useState } from 'react';

export function useOnScroll(container: React.RefObject<HTMLDivElement>, onSwipe?: () => void) {
  const [isAutoScrolled, setAutoScrolled] = useState(false);

  return useCallback(() => {
    const scrollContainer = container.current;

    /* istanbul ignore else */
    if (scrollContainer) {
      /**
       * Пропускаем первый скролл (так как он автоскролл к правой части графика)
       */
      if (!isAutoScrolled && scrollContainer.scrollLeft + scrollContainer.offsetWidth === scrollContainer.scrollWidth) {
        setAutoScrolled(true);

        return;
      }

      // Отсутствие onSwipe не проверить
      /* istanbul ignore else */
      if (onSwipe && isAutoScrolled) {
        onSwipe();
      }
    }
  }, [container, isAutoScrolled, onSwipe]);
}
